export default {
  init() {
    // JavaScript to be fired on the Thank You page
    $('#nextStep').click(function () {
      $('#step_1').fadeOut();

      setTimeout(function () {
        $('#step_2').fadeIn('slow');
      }, 400);
    });
  },
  finalize() {
    // JavaScript to be fired on the Thank You page, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/thank_you.js